export default "__VITE_ASSET__57neBt4v__"